import { Fragment, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Button, Col, Grid, Image, Row, Space, Typography } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';

import IconCustom from 'src/components/Icon/Custom';
import messageC from 'src/components/Message';
import { renderDetailArticle } from 'src/utils/func/render-article';

import classes from './style.module.less';

const EventDetail = (props: any) => {
	const { xl, lg, xs } = Grid.useBreakpoint();
	const router = useRouter();
	const url = `${process.env.NEXT_PUBLIC_WEB_URL}${router.asPath?.split('?')[0]}`;
	const copyLink = () => {
		const cb = navigator.clipboard;

		cb.writeText(`${window.location.origin}${router.asPath?.split('?')[0]}`).then(() => {
			messageC('Copied');
		});
	};
	const descriptionWeb = !props?.description_web ? props?.description : props?.description_web
	const sosmed = {
		social_media: [
			{
				icon: '/images/default/logoFbColor.svg',
				name: 'Facebook',
				deeplink: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
			},
			{
				icon: '/images/default/logoXColor.svg',
				name: 'Twitter',
				deeplink: `https://twitter.com/intent/tweet?url=${url}`,
			},
			{
				icon: '/images/default/logoWaColor.svg',
				name: 'WA',
				deeplink: `https://api.whatsapp.com/send?text=${url}`,
			},
			{
				icon: '/images/default/logoCopy.svg',
				name: 'copylink',
				deeplink: '',
			},
		],
	};

	useEffect(() => {
		window.scrollBy({
			top: 5,
			left: 0,
			behavior: 'smooth',
		});
	}, []);

	return (
		<div className={classes['wrap-article-detail']}>
			<div className={classes.pagehero}>
				<div className={classes['page-body-wrap']}>
					<div className="container">
						<Row>
							<Col md={11} sm={11} xs={24} lg={11} xl={11}>
								<div className={classes.section}>
									<Image
										src={props.image_files[0].path}
										height={xs ? 305 : 467}
										width={xs ? 305 : 467}
										style={{ borderRadius: '8px' }}
										preview={false}
									/>
								</div>
							</Col>
							<Col md={13} sm={13} xs={24} lg={13} xl={13}>
								<div className={classes.sectionright}>
									<h1 className={classes.title}>{props.title}</h1>
									<Row>
										<Col sm={2} md={2} lg={2} xl={2} xs={2} className="d-flex align-items-center">
											<IconCustom iconName="d_calender" />
										</Col>
										<Col sm={22} md={22} lg={22} xl={22} xs={22}>
											<Row>
												<Col>
													<Text className={classes.paragraph1}>{props.start_date_text}</Text>
												</Col>
											</Row>
											<Row>
												<Col>
													<Text className={classes.paragraph2}>{props.start_hour_text}</Text>
												</Col>
											</Row>
										</Col>
									</Row>
									<br />
									<Row>
										<Col sm={2} md={2} lg={2} xl={2} xs={2} className="d-flex align-items-center">
											<IconCustom
												iconName={props.address.length !== 0 ? 'd_location' : 'd_video'}
											/>
										</Col>
										<Col sm={22} md={22} lg={22} xl={22} xs={22}>
											<Text className={classes.paragraph2}>
												{props.address.length !== 0 ? `${props.address}` : 'Event Online'}
											</Text>
										</Col>
									</Row>
									<br />
									<Row>
										<Col sm={2} md={2} lg={2} xl={2} xs={2} className="d-flex align-items-center">
											<IconCustom iconName="d_speaker" />
										</Col>
										<Col sm={22} md={22} lg={22} xl={22} xs={22}>
											<Text className={classes.paragraph2}>{props.guest_speaker}</Text>
										</Col>
									</Row>
									<div className={classes.btnFooter}>
										<Button
											className={classes.btn}
											size="large"
											id="btn-cek-acara"
											onClick={() => window.open(props.ur_link)}
											disabled={props.event_status_text === 'Selesai' ? true : false}
										>
											Yuk, Cek Acaranya
										</Button>
									</div>
									<Row style={{ paddingTop: '16px', paddingBottom: '20px' }}>
										<Col sm={21} md={21} lg={21} xl={21} xs={24}>
											<Space className={classes.icons} size="middle">
												<Paragraph>
													<Typography className={classes.sosmed}>Bagikan</Typography>
												</Paragraph>
												{sosmed.social_media?.map((item: any) => {
													return item.name !== 'copylink' ? (
														<Fragment key={item.name}>
															<a
																href={item.deeplink}
																rel="nofollow noreferrer"
																id={'detail-artikel-' + item.name}
																target="_blank"
															>
																{item.icon && (
																	<Image
																		key={item.name}
																		className={classes['socmed-icon']}
																		width={!xl && lg ? 28 : xs ? 24 : 32}
																		height={!xl && lg ? 28 : xs ? 24 : 32}
																		src={item.icon}
																		alt={item.name}
																		preview={false}
																		style={{ cursor: 'pointer' }}
																	/>
																)}
															</a>
														</Fragment>
													) : (
														<Fragment key={item.name}>
															<div onClick={copyLink} id="CopyLink">
																{item.icon && (
																	<Image
																		key={item.name}
																		className={classes['socmed-icon']}
																		width={!xl && lg ? 28 : xs ? 24 : 32}
																		height={!xl && lg ? 28 : xs ? 24 : 32}
																		src={item.icon}
																		alt={item.name}
																		preview={false}
																		style={{ cursor: 'pointer' }}
																	/>
																)}
															</div>
														</Fragment>
													);
												})}
											</Space>
										</Col>
									</Row>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</div>
			<Row>
				<Col>
					<div style={{ marginTop: '30px' }}>
						<h2 className={classes.title1}>Tentang Acara</h2>
					</div>
					<div style={{ marginTop: '12px' }}>
						{/* <Typography className={classes.paragraph3}>{props.description}</Typography> */}

						<div className={classes['article-image']}
							dangerouslySetInnerHTML={{ __html: renderDetailArticle(descriptionWeb) }}
						/>
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default EventDetail;
